(() => {
  'use strict';

  if (window.ksCartGiftWrapInit) return;

  window.ksCartGiftWrapInit = true;
  window.ksCartGiftWrapLoading = false;
  window.ksCartGiftWrapCleanupRunning = false;
  window.ksCartGiftWrapCleanupPending = false;

  function ksClosest(element, selector) {
    while (element && element.nodeType === 1) {
      if (element.matches && element.matches(selector)) return element;
      element = element.parentElement;
    }
    return null;
  }

  function ksPostCart(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    });
  }


  /*
   * Eine von JK hinzugefügte Geschenkverpackung erkennen wir in erster Linie
   * an den eigenen privaten Line-Item-Properties. Das ist absichtlich nicht
   * nur an die aktuelle Variantenliste gekoppelt: Wird eine Verpackung später
   * im Admin gelöscht, kann ein älterer Warenkorb trotzdem noch sauber
   * aufgeräumt werden.
   */
  function ksIsLinkedGiftWrap(item) {
    const properties = item && item.properties ? item.properties : {};

    return Boolean(
      properties['_Hauptartikel Line Key'] &&
      properties['_Auswahl']
    );
  }

  function ksGiftWrapParentKey(item) {
    const nativeParentKey = item && item.parent_relationship
      ? item.parent_relationship.parent_key
      : '';

    if (nativeParentKey) return String(nativeParentKey);

    const properties = item && item.properties ? item.properties : {};
    return String(properties['_Hauptartikel Line Key'] || '');
  }

  function ksCartHasGiftWrapForLine(cart, mainLineKey) {
    return cart.items.some(item => {
      if (!ksIsLinkedGiftWrap(item)) return false;
      return ksGiftWrapParentKey(item) === String(mainLineKey);
    });
  }

  function ksAnalyzeGiftWraps(cart) {
    const mainLineKeys = new Set(
      cart.items
        .filter(item => !ksIsLinkedGiftWrap(item))
        .map(item => String(item.key))
    );

    const groups = new Map();
    const updates = {};
    const migrations = [];

    cart.items.forEach(item => {
      if (!ksIsLinkedGiftWrap(item)) return;

      const linkedLineKey = ksGiftWrapParentKey(item);

      /*
       * Native parent_relationship ist die führende Zuordnung. Der zusätzlich
       * gespeicherte private Line-Key bleibt nur als Fallback für ältere Carts.
       * Das ist wichtig, weil Shopify line_item.key z. B. durch Rabatte ändern kann.
       */
      /* Hauptartikel existiert nicht mehr -> alte/verwaiste Box entfernen. */
      if (!linkedLineKey || !mainLineKeys.has(linkedLineKey)) {
        updates[item.key] = 0;
        return;
      }

      if (!groups.has(linkedLineKey)) groups.set(linkedLineKey, []);
      groups.get(linkedLineKey).push(item);
    });

    groups.forEach((items, linkedLineKey) => {
      /*
       * Native Shopify-Nesting bevorzugen. Falls noch eine alte V6-Box ohne
       * parent_relationship existiert, wird sie einmalig migriert.
       */
      const nested = items.find(item => {
        const parentKey = item && item.parent_relationship
          ? item.parent_relationship.parent_key
          : '';
        return parentKey && String(parentKey) === String(linkedLineKey);
      });

      const keeper = nested || items[0];

      items.forEach(item => {
        if (item.key !== keeper.key) updates[item.key] = 0;
      });

      if (nested) {
        if (Number(nested.quantity) !== 1) updates[nested.key] = 1;
        return;
      }

      migrations.push({
        originalKey: keeper.key,
        id: Number(keeper.variant_id),
        parentLineKey: linkedLineKey,
        properties: keeper.properties || {}
      });
    });

    return { updates, migrations };
  }

  let quantityLockTimer;

  function ksLockGiftWrapQuantities() {

    const giftWrapLineKeys = new Set(
      Array.from(document.querySelectorAll('[data-ks-giftwrap-item-line-key]'))
        .map(marker => String(marker.getAttribute('data-ks-giftwrap-item-line-key') || ''))
        .filter(Boolean)
    );

    if (!giftWrapLineKeys.size) return;

    document.querySelectorAll('input.quantity-input[data-line-key]').forEach(input => {
      const lineKey = String(input.getAttribute('data-line-key') || '');
      if (!giftWrapLineKeys.has(lineKey)) return;

      input.readOnly = true;
      input.setAttribute('aria-disabled', 'true');
      input.setAttribute('tabindex', '-1');
      input.setAttribute('inputmode', 'none');
      input.classList.add('ks-giftwrap-quantity-locked');
    });
  }

  function ksScheduleGiftWrapQuantityLock(delay = 0) {
    clearTimeout(quantityLockTimer);
    quantityLockTimer = setTimeout(ksLockGiftWrapQuantities, delay);
  }

  function ksNormalizeGiftWraps() {
    if (window.ksCartGiftWrapCleanupRunning) {
      window.ksCartGiftWrapCleanupPending = true;
      return Promise.resolve(false);
    }

    window.ksCartGiftWrapCleanupRunning = true;

    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Warenkorb konnte nicht geladen werden');
        }
        return response.json();
      })
      .then(async cart => {
        const analysis = ksAnalyzeGiftWraps(cart);
        const updates = Object.assign({}, analysis.updates);
        let changed = false;

        /*
         * V7: Bereits vorhandene alte Geschenkverpackungen werden einmalig in
         * Shopifys native "nested cart lines" migriert. Dadurch steht die Box
         * auch im Checkout direkt unter ihrem Hauptartikel.
         *
         * Erst neue verschachtelte Line anlegen, dann die alte entfernen. Wenn
         * Shopify das Anlegen ablehnt, bleibt die bisherige Box sicher erhalten.
         */
        if (analysis.migrations.length) {
          const migrationResponse = await ksPostCart('/cart/add.js', {
            items: analysis.migrations.map(migration => ({
              id: migration.id,
              quantity: 1,
              parent_line_key: migration.parentLineKey,
              properties: migration.properties
            }))
          });

          if (!migrationResponse.ok) {
            throw new Error('Geschenkverpackungen konnten nicht verschachtelt werden');
          }

          analysis.migrations.forEach(migration => {
            updates[migration.originalKey] = 0;
          });
          changed = true;
        }

        const updateKeys = Object.keys(updates);
        if (updateKeys.length) {
          const updateResponse = await ksPostCart('/cart/update.js', { updates });
          if (!updateResponse.ok) {
            throw new Error('Geschenkverpackungen konnten nicht bereinigt werden');
          }
          changed = true;
        }

        return changed;
      })
      .catch(error => {
        console.error('Gift-Wrap Cleanup Fehler:', error);
        return false;
      })
      .then(result => {
        window.ksCartGiftWrapCleanupRunning = false;

        if (window.ksCartGiftWrapCleanupPending) {
          window.ksCartGiftWrapCleanupPending = false;
          ksScheduleGiftWrapCleanup(0);
        }

        return result;
      });
  }

  let cleanupTimer;

  function ksScheduleGiftWrapCleanup(delay = 200) {
    clearTimeout(cleanupTimer);

    cleanupTimer = setTimeout(() => {
      ksNormalizeGiftWraps().then(changed => {
        if (!changed) return;

        if (window.location.pathname === '/cart') {
          window.location.reload();
          return;
        }

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
      });
    }, delay);
  }

  /*
   * Früher: 700 ms Wartezeit. Jetzt: 200 ms.
   * Das ist schnell genug für eine direkte Reaktion, lässt dem Theme aber
   * noch kurz Zeit, seine eigene Cart-Aktion abzuschließen.
   */
  ksScheduleGiftWrapCleanup();
  ksScheduleGiftWrapQuantityLock(0);

  document.documentElement.addEventListener('cart:change', () => {
    ksScheduleGiftWrapCleanup(200);
    ksScheduleGiftWrapQuantityLock(80);
  });

  document.documentElement.addEventListener('cart:refresh', () => {
    ksScheduleGiftWrapCleanup(200);
    ksScheduleGiftWrapQuantityLock(80);
  });

  function ksObserveGiftWrapQuantityAreas() {
    const targets = [];

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) targets.push(cartDrawer);

    if (window.location.pathname === '/cart') {
      const mainCart = document.querySelector('.shopify-section--main-cart') || document.querySelector('main');
      if (mainCart) targets.push(mainCart);
    }

    targets.forEach(target => {
      if (target.dataset.ksGiftWrapQuantityObserver === '1') return;
      target.dataset.ksGiftWrapQuantityObserver = '1';

      const quantityObserver = new MutationObserver(() => {
        ksScheduleGiftWrapQuantityLock(40);
      });

      quantityObserver.observe(target, {
        childList: true,
        subtree: true
      });
    });
  }

  ksObserveGiftWrapQuantityAreas();

  document.addEventListener('shopify:section:load', () => {
    ksObserveGiftWrapQuantityAreas();
    ksScheduleGiftWrapQuantityLock(0);
  });

  document.addEventListener('click', event => {
    const button = ksClosest(event.target, '[data-cart-giftwrap-add]');

    if (!button) return;
    if (window.ksCartGiftWrapLoading) return;

    event.preventDefault();
    event.stopPropagation();

    window.ksCartGiftWrapLoading = true;

    const giftWrapId = button.getAttribute('data-gift-wrap-id');
    const giftWrapTitle = button.getAttribute('data-gift-wrap-title');
    const mainVariantId = button.getAttribute('data-main-variant-id');
    const mainLineKey = button.getAttribute('data-main-line-key');
    const mainTitle = button.getAttribute('data-main-title');
    const mainSku = button.getAttribute('data-main-sku') || '';

    if (!giftWrapId || !mainVariantId || !mainLineKey) {
      window.ksCartGiftWrapLoading = false;
      return;
    }

    const addButtons = document.querySelectorAll('[data-cart-giftwrap-add]');
    addButtons.forEach(addButton => { addButton.disabled = true; });

    fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Warenkorb konnte nicht geladen werden');
        }
        return response.json();
      })
      .then(cart => {
        /* Doppelklick/Race: niemals eine zweite Verpackung für dieselbe Line. */
        if (ksCartHasGiftWrapForLine(cart, mainLineKey)) {
          return { alreadyExists: true };
        }

        const properties = {
          '_Hauptartikel Variant ID': Number(mainVariantId),
          '_Hauptartikel Line Key': mainLineKey,
          '_Auswahl': giftWrapTitle
        };

        if (mainSku) {
          properties['Gehört zu Art.-Nr.'] = mainSku;
        } else {
          properties['Gehört zu Artikel'] = mainTitle;
        }

        return ksPostCart('/cart/add.js', {
          id: Number(giftWrapId),
          quantity: 1,
          parent_line_key: mainLineKey,
          properties
        }).then(response => {
          if (!response.ok) {
            throw new Error('Geschenkverpackung konnte nicht hinzugefügt werden');
          }

          return { alreadyExists: false };
        });
      })
      .then(result => {
        /*
         * Nicht mehr auf einen zweiten /cart.js-Normalisierungslauf warten.
         * Die sichtbare Cart-Aktualisierung erfolgt sofort; die Normalisierung
         * läuft anschließend über die Cart-Events im Hintergrund.
         */
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', { bubbles: true })
        );

        if (window.location.pathname === '/cart') {
          window.location.reload();
          return;
        }

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.show === 'function') {
          cartDrawer.show();
        }

        if (result && result.alreadyExists) {
          ksScheduleGiftWrapCleanup(0);
        }
      })
      .catch(error => {
        console.error('Cart Geschenkverpackung Fehler:', error);
        alert('Die Geschenkverpackung konnte leider nicht hinzugefügt werden.');
      })
      .then(() => {
        window.ksCartGiftWrapLoading = false;
        addButtons.forEach(addButton => { addButton.disabled = false; });
      });
  });
})();
